const TableTopFilter = ({ children, className = '' }) => {
  return <div className={`app-table-top-filter ${className}`}>{children}</div>;
};

export default TableTopFilter;
